<template>
  <div>
    <p>決済をキャンセルしました</p>
    <v-flex mb-4 xs6>
      <div class="ma-4">
        <v-btn
          v-if="linkTalkScreen"
          rounded
          class="custom-transform-class text-none"
          color="success"
          :href="linkTalkScreen"
          >トーク画面へ移動</v-btn
        >
      </div>
    </v-flex>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data: () => ({}),
  created() {
    this.$store.state.appBar = false;
    this.$store.state.title = "お支払い";
    this.$store.state.cart = false;
  },
  async mounted() {},
  computed: {
    ...mapGetters("settings", ["linkTalkScreen"]),
  },
  watch: {
    // DB 設定読み込んだ後に行う
    linkTalkScreen: function () {
      this.hideProgress();
    },
  },
  methods: {
    ...mapActions(["hideProgress"]),
  },
};
</script>
